<slb-navigation-framework [hasSidenav]="false" [notifications]="false" [applicationLogo]="slbLogo"
    [isDelfiApp]="false" [displayViewModeButtons]="false" [hideBackgroundSelector]="true"
    [pageTitle]="'Developer Portal'" [applicationName]="'Developer Portal'" [immersiveMode]="false">
    <slb-framework-toolbar>
        <ng-content *ngTemplateOutlet="toolbar"></ng-content>
    </slb-framework-toolbar>
    <slb-framework-content>
        <ng-content *ngTemplateOutlet="content"></ng-content>
    </slb-framework-content>
</slb-navigation-framework>

<ng-template #toolbar>
    <delfi-gui-user-profile class="user-profile" [resetDp]="false" [showContextInNavbar]="true" [showContextInNavbar]="true" [showVerticalSeparator]="true" [userRoleConfiguration]="managerRoles"
        (signOutEvent)="logout()" (contextChanges)="onContextChanges($event)">
    </delfi-gui-user-profile>
</ng-template>

<ng-template #content>
    <slb-error-page
        [errorTitle]="'User context must be selected.'"
        [errorDescription]="'To use this application, you must select a billing account, department from your user context, found in the upper-right corner of this page.'">
    </slb-error-page>
</ng-template>